// Libraries
import { ComponentProps, createElement, FunctionComponent, Attributes } from 'react';
// Types
import { ComponentsKeys, CellMapperMap, CellMapper } from './CardTable.type';

/**
 * Renders a component dynamically based on the provided component key and props.
 * @template T - Generic type parameter representing the component keys.
 * @param {ComponentsKeys} component - The component key.
 * @param {ComponentProps<CellMapperMap[T]>} props - The props for the component.
 * @returns {ReactElement} - The rendered component as a JSX element.
 */
export const renderComponent = <T extends ComponentsKeys>(
  component: ComponentsKeys,
  props: ComponentProps<CellMapperMap[T]>
) => {
  return createElement(CellMapper[component] as FunctionComponent, props as Attributes);
};
